export default "__VITE_ASSET__Ur6k0qkA__"